export const instrumentEndpoints = (builder) => ({
    getNigerianInstruments: builder.query({
        query: () => ({
            url: `/instruments/nigeria`,
            method: 'get'
        }),
    }),
    UpdateInstrument: builder.mutation({
        query: ({ id, meta, ...data }) => ({ url: `/instruments/${id}`, method: 'patch', body: { ...data, meta } })
    }),
})